import axios from 'axios';

export const productUpgradeRequest = async (userEmail?: string, appName?: string) => {
  try {
    if (!userEmail || !appName) {
      throw new Error('Missing required parameters');
    }
    await axios.post('/api/feedback/ProductSubscriptionUpgrade?_id=ProductSubscriptionUpgrade', {
      userEmail,
      appName
    });
    return Promise.resolve();
  } catch (error) {
    return Promise.reject(error);
  }
};
